import { Button, Grid2, Stack } from "@mui/material";
import CheckboxInput from "../../../input/CheckboxInput";
import {
  ADD_RIGHT,
  DELETE_RIGHT,
  UPDATE_RIGHT,
  VIEW_RIGHT,
  VIEWOFOTHER_RIGHT,
} from "../../../../../utils/constants";

const rightMapper: { [key: string]: string } = {
  [VIEW_RIGHT]: "Xem",
  [VIEWOFOTHER_RIGHT]: "Xem của người khác",
  [ADD_RIGHT]: "Thêm mới",
  [UPDATE_RIGHT]: "Cập nhật",
  [DELETE_RIGHT]: "Xóa",
};

interface ICheckBoxComponent {
  right: string;
  module: any;
  currentRight: any;
  addOrUpdateRight: (obj: {
    type: string;
    value: boolean;
    viewOfOther_user_groups?: string[];
  }) => void;
  trangThais: any[];
}

function CheckBoxComponent({
  right,
  module,
  currentRight,
  addOrUpdateRight,
  trangThais = [],
}: ICheckBoxComponent) {
  //   const [openModal, setOpenModal] = useState<boolean>(false);

  return (
    <>
      {/* {openModal && (
        <ModalBase
          title="Trạng thái có quyền"
          open={openModal}
          width="500px"
          handleClose={() => setOpenModal(false)}
        >
          <Stack
            sx={{
              width: "100%",
              paddingRight: "2px",
              maxHeight: "calc(90vh - 20px - 39px - 39px)",
              overflow: "auto",
            }}
          >
            {trangThais?.map((trangThai) => {
              let isChecked =
                currentRight?.[`${right}_trang_thai`]?.[trangThai.stt];
              if (isChecked === undefined) {
                isChecked = true;
              }
              return (
                <CheckboxInput
                  key={trangThai._id}
                  label={trangThai.ten_trang_thai}
                  checked={isChecked}
                  onChange={(e) => {
                    addOrUpdateRight({
                      type: `${right}_trang_thai`,
                      value: {
                        ...currentRight?.[`${right}_trang_thai`],
                        [trangThai.stt]: e.target.checked,
                      },
                    });
                  }}
                />
              );
            })}
          </Stack>
        </ModalBase>
      )} */}
      <Grid2 size={{ xs: right === "viewOfOther" ? 3 : 2.25 }}>
        <Stack sx={{ width: "100%" }}>
          <CheckboxInput
            disabled={
              (right === VIEW_RIGHT || right === VIEWOFOTHER_RIGHT) &&
              module.code === "participant"
            }
            label={rightMapper[right]}
            checked={currentRight?.[right] || false}
            onChange={(e) => {
              addOrUpdateRight({ type: right, value: e.target.checked });
            }}
          />
          {currentRight?.[right] === true &&
            !!trangThais &&
            trangThais.length > 0 && (
              <Button
                variant="outlined"
                sx={{ width: "fit-content" }}
                // onClick={() => setOpenModal(true)}
              >
                Trạng thái
              </Button>
            )}
        </Stack>
      </Grid2>
    </>
  );
}
export default CheckBoxComponent;
